export default {
    disabledStyle: {
        cursor: "not-allowed",
        opacity: 0.5,
    },
}